import * as Specular$dComponents$dCommon from "../Specular.Components.Common/index.js";
import * as Specular$dComponents$dIconList from "../Specular.Components.IconList/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
const iconD = modifiers => icn => Specular$dComponents$dCommon.element()("span")([
  Specular$dDom$dElement.class_("material-symbols-outlined"),
  Specular$dComponents$dCommon.attrsModifier((() => {
    const $0 = {};
    $0["aria-hidden"] = "true";
    return $0;
  })())
])(modifiers)(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(Specular$dComponents$dIconList.description)(icn)));
const iconD_ = icn => iconD([])(icn);
const icon = mods => icn => iconD(mods)((() => {
  const n = Specular$dInternal$dIncremental.constant(icn);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})());
const icon_ = icn => icon([])(icn);
export {icon, iconD, iconD_, icon_};
